"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

type ChipVariant = "outline" | "neutral" | "primary" | "destructive";

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  children: React.ReactNode;
}

const VARIANT_CLASS: Record<ChipVariant, string> = {
  outline:
    "border border-border/75 bg-muted/25 text-muted-foreground",
  neutral:
    "border border-border/75 bg-muted/38 text-foreground",
  primary:
    "border border-primary/35 bg-primary/8 text-primary",
  destructive:
    "border border-destructive/35 bg-destructive/8 text-destructive",
};

/**
 * Single primitive for the tiny uppercase status pill used across cards
 * and list rows (Shared, v2, Refining, Paid, Archived, etc.). Replaces
 * the ad-hoc `inline-flex items-center px-2 py-0.5 text-overline border …`
 * pattern that is copy-pasted in 20+ places.
 */
export function Chip({
  variant = "outline",
  className,
  children,
  ...props
}: ChipProps) {
  return (
    <span
      className={cn(
        "inline-flex min-h-[16px] items-center px-1.5 py-px text-[10px] font-semibold uppercase tracking-[0.03em] leading-none tabular-nums whitespace-nowrap rounded-none",
        VARIANT_CLASS[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
